type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

// eslint-disable-next-line camelcase
export const i18n_my_premium_trainings: Phrase = locale => {
  const fallback = 'My Premium Trainings';
  const phrases: { [key: string]: undefined | string } = {
    en: `My Premium Trainings`,
    es: `Mis Cursos Premium`,
  };
  return phrases[locale] || phrases.en || fallback;
};
